import { localStorage } from "dash-ui";

export interface RestApiCallOptions<T> {
  endpoint: string;
  method?: string;
  body?: T;
}

/**
 * Utility function for making REST API calls outside of React hooks
 * Useful for callbacks, event handlers, etc.
 */
export async function restApiCall<T = any, U = any>({
  endpoint,
  method = "POST",
  body,
}: RestApiCallOptions<T>): Promise<U> {
  const response = await fetch(
    `${process.env["REACT_APP_REST"]}/${endpoint}`,
    {
      method,
      headers: {
        accessToken: localStorage.getAccessToken() || "",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );

  if (!response.ok) {
    throw new Error(`Network response was not ok: ${response.statusText}`);
  }

  return response.json();
}